import React from 'react'
import { Link } from 'react-router-dom'
import { PageHeader, Button } from 'antd'
import { IdcardOutlined } from '@ant-design/icons'

import Loader from '../../../../components/loader'
import { LAYOUT_VENDOR_USER_SHOW } from '../../navigation'
import Dashboard from './dashboard'

import {
  useFetchHomeTasks,
  useFetchHomePurchaseOrders,
  getTasksInProgress,
  getTasksWithUpcomingDeadline,
  getTasksWaitingConfirmation,
  getPOsInReview
} from '../../../../hooks/vendor/home'

const Main = () => {
  const { data: tasks, isLoading: isTasksLoading, isError: isTasksError } = useFetchHomeTasks()
  const { data: purchaseOrders, isLoading: isPurchaseOrdersLoading, isError: isPurchaseOrdersError } = useFetchHomePurchaseOrders()

  if (isTasksLoading || isPurchaseOrdersLoading) {
    return (<Loader loading />)
  }

  if (isTasksError || isPurchaseOrdersError) {
    return (<>ERROR</>)
  }

  const isLoading = isTasksLoading || isPurchaseOrdersLoading
  const isError = isTasksError || isPurchaseOrdersError

  const offered = getTasksWaitingConfirmation(tasks)
  const inProgress = getTasksInProgress(tasks)
  const upcoming = getTasksWithUpcomingDeadline(tasks)

  const purchaseOrdersInReview = getPOsInReview(purchaseOrders)

  const dashboardProps = {
    inProgress,
    offered,
    upcoming,
    purchaseOrdersInReview,
    isLoading,
    isError
  }

  return (
    <>
      <PageHeader
        ghost={false}
        title='Welcome'
        extra={[
          <Link to={LAYOUT_VENDOR_USER_SHOW} key='1'>
            <Button icon={<IdcardOutlined />} size='small'>
              Settings
            </Button>
          </Link>
        ]}
      />

      <Loader loading={isLoading} />
      <br />

      <Dashboard {...dashboardProps} />
    </>
  )
}

export default Main
